import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.field');
import { OnInit, OnDestroy, ChangeDetectorRef as CDR } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import { IUser } from '../@types';

declare let wiz: any;

const AUTO_LOGIN_KEY = 'inspectpro.login.auto';
const ACTIVE_SYNC_STATUSES = ['pending', 'syncing', 'failed'];

@Component({
    selector: 'wiz-layout-field',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.field/view.scss */
@import url("pretendard.min.css");
.field-layout {
  font-family: "Pretendard", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  background-color: #FBFDFD;
  display: flex;
  flex-direction: column;
}

.field-nav {
  height: 72px;
  background-color: #FFFFFF;
  border-bottom: 1px solid #E0E2E6;
  display: flex;
  align-items: center;
  padding: 0 1.5rem;
  position: relative;
  z-index: 100;
}

.nav-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.nav-left {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
}
.nav-left .app-icon-container {
  width: 40px;
  height: 40px;
  background-color: #1A73E8;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.nav-left .app-icon-container i {
  color: white;
  font-size: 1.15rem;
}
.nav-left .app-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1C1B1F;
  letter-spacing: 0;
}

.nav-right {
  display: flex;
  align-items: center;
  gap: 1.25rem;
}

.status-chip-group {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.status-chip-wrap {
  position: relative;
}

.nav-chip {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.875rem;
  background-color: #F1F3F4;
  border-radius: 12px;
  font-size: 0.875rem;
  font-weight: 600;
  color: #49454F;
}
.nav-chip i {
  font-size: 0.9rem;
  color: #79747E;
}
.nav-chip .status-indicator {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex: 0 0 auto;
}
.nav-chip.online {
  background-color: #E6F4EA;
  color: #137333;
}
.nav-chip.online .status-indicator {
  background-color: #34A853;
}
.nav-chip.online i {
  color: #34A853;
}
.nav-chip.offline {
  background-color: #FCE8E6;
  color: #C5221F;
}
.nav-chip.offline .status-indicator {
  background-color: #EA4335;
}
.nav-chip.offline i {
  color: #EA4335;
}
.nav-chip.syncing {
  background-color: #FEF7E0;
  color: #8A5A00;
}
.nav-chip.syncing .status-indicator {
  background-color: #F9AB00;
}
.nav-chip.syncing i {
  color: #8A5A00;
}
.nav-chip.cached-session {
  background-color: #EEF2FF;
  color: #3730A3;
}
.nav-chip.cached-session i {
  color: #4F46E5;
}

.network-chip {
  border: 0;
  min-height: 40px;
  font-family: inherit;
  white-space: nowrap;
  transition: box-shadow 0.15s ease, transform 0.15s ease;
}
.network-chip:hover {
  box-shadow: 0 2px 8px rgba(28, 27, 31, 0.12);
}
.network-chip:active {
  transform: translateY(1px);
}

.network-label {
  line-height: 1;
}

.sync-count-label {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 22px;
  padding: 0 0.5rem;
  border-radius: 999px;
  background: #FFFFFF;
  border: 1px solid rgba(197, 34, 31, 0.2);
  color: #A50E0E;
  font-size: 0.75rem;
  font-weight: 800;
  white-space: nowrap;
}
.sync-count-label.danger {
  background: #FCE8E6;
  border-color: rgba(197, 34, 31, 0.32);
}

.sync-chevron {
  font-size: 0.75rem !important;
  transition: transform 0.15s ease;
}
.sync-chevron.open {
  transform: rotate(180deg);
}

.sync-detail-panel {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  width: min(360px, 100vw - 32px);
  padding: 0.875rem;
  border: 1px solid #DADCE0;
  border-radius: 8px;
  background: #FFFFFF;
  box-shadow: 0 12px 30px rgba(28, 27, 31, 0.16);
  color: #1C1B1F;
  z-index: 200;
}

.sync-detail-header {
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}
.sync-detail-header strong,
.sync-detail-header span {
  display: block;
}
.sync-detail-header strong {
  font-size: 0.95rem;
  font-weight: 800;
  line-height: 1.25;
}
.sync-detail-header span {
  margin-top: 0.2rem;
  color: #49454F;
  font-size: 0.78rem;
  font-weight: 500;
  line-height: 1.35;
}

.sync-detail-close {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  border: 0;
  border-radius: 8px;
  background: #F1F3F4;
  color: #49454F;
  cursor: pointer;
}
.sync-detail-close i {
  font-size: 0.8rem;
  color: inherit;
}
.sync-detail-close:hover {
  background: #E8EAED;
  color: #1C1B1F;
}

.sync-loading,
.sync-empty {
  min-height: 64px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #49454F;
  font-size: 0.84rem;
  font-weight: 600;
}
.sync-loading i,
.sync-empty i {
  color: #1A73E8;
}

.sync-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.sync-row {
  display: grid;
  grid-template-columns: 30px minmax(0, 1fr) auto;
  align-items: center;
  gap: 0.625rem;
  padding: 0.625rem;
  border: 1px solid #E0E2E6;
  border-radius: 8px;
  background: #FBFDFD;
}
.sync-row.pending {
  border-color: #D2E3FC;
  background: #F8FBFF;
}
.sync-row.syncing {
  border-color: #FDE293;
  background: #FFFDF5;
}
.sync-row.failed {
  border-color: #FAD2CF;
  background: #FFFBFA;
}

.sync-row-icon {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #E8F0FE;
  color: #1A73E8;
}
.sync-row-icon i {
  color: inherit;
  font-size: 0.82rem;
}
.failed .sync-row-icon {
  background: #FCE8E6;
  color: #C5221F;
}
.syncing .sync-row-icon {
  background: #FEF7E0;
  color: #8A5A00;
}

.sync-row-body {
  min-width: 0;
}
.sync-row-body strong,
.sync-row-body span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sync-row-body strong {
  font-size: 0.86rem;
  font-weight: 800;
  line-height: 1.25;
}
.sync-row-body span {
  margin-top: 0.15rem;
  color: #49454F;
  font-size: 0.74rem;
  font-weight: 500;
}

.sync-row-status {
  min-width: 44px;
  padding: 0.2rem 0.45rem;
  border-radius: 999px;
  background: #E8F0FE;
  color: #1A73E8;
  text-align: center;
  font-size: 0.72rem;
  font-weight: 800;
  white-space: nowrap;
}
.failed .sync-row-status {
  background: #FCE8E6;
  color: #C5221F;
}
.syncing .sync-row-status {
  background: #FEF7E0;
  color: #8A5A00;
}

.sync-more {
  padding: 0.35rem 0.625rem;
  color: #49454F;
  font-size: 0.76rem;
  font-weight: 700;
}

.sync-detail-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 0.875rem;
}

.sync-action {
  min-height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  padding: 0 0.75rem;
  border-radius: 8px;
  border: 1px solid #DADCE0;
  background: #FFFFFF;
  color: #49454F;
  font-size: 0.82rem;
  font-weight: 800;
  cursor: pointer;
}
.sync-action i {
  color: inherit;
  font-size: 0.78rem;
}
.sync-action.primary {
  border-color: #1A73E8;
  background: #1A73E8;
  color: #FFFFFF;
}
.sync-action:disabled {
  cursor: not-allowed;
  opacity: 0.48;
}

.profile-chip {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.375rem 0.375rem 0.375rem 1rem;
  background-color: #FFFFFF;
  border: 1px solid #E0E2E6;
  border-radius: 16px;
}
.profile-chip .user-details {
  display: flex;
  flex-direction: column;
}
.profile-chip .user-details .user-name {
  font-size: 0.9375rem;
  font-weight: 700;
  color: #1C1B1F;
  line-height: 1.2;
}
.profile-chip .user-details .user-label {
  font-size: 0.75rem;
  font-weight: 500;
  color: #49454F;
}
.profile-chip .avatar-surface {
  width: 32px;
  height: 32px;
  background-color: #E8F0FE;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.profile-chip .avatar-surface i {
  color: #1A73E8;
  font-size: 0.8125rem;
}

.icon-btn-logout,
.icon-btn-diagnostics {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: transparent;
  border: none;
  color: #49454F;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  cursor: pointer;
}
.icon-btn-logout:hover,
.icon-btn-diagnostics:hover {
  background-color: #F1F3F4;
  color: #1C1B1F;
}
.icon-btn-logout i,
.icon-btn-diagnostics i {
  font-size: 1.125rem;
}

.icon-btn-diagnostics:hover {
  background-color: #E8F0FE;
  color: #1A73E8;
}

.field-content {
  flex: 1;
  height: calc(100vh - 72px);
}

button, .cursor-pointer {
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}

@media (max-width: 1180px) {
  .field-nav {
    padding: 0 1rem;
  }
  .nav-right {
    gap: 0.75rem;
  }
  .nav-chip {
    padding: 0.45rem 0.7rem;
  }
  .profile-chip {
    padding-left: 0.75rem;
  }
}
@media (max-width: 980px) {
  .time-chip {
    display: none;
  }
  .profile-chip .user-details .user-label {
    display: none;
  }
  .sync-count-label {
    font-size: 0.72rem;
    padding: 0 0.4rem;
  }
}
@media (max-width: 760px) {
  .app-title,
  .profile-chip .user-details {
    display: none;
  }
  .nav-right {
    gap: 0.5rem;
  }
  .sync-detail-panel {
    right: -84px;
  }
}`],
})
export class LayoutFieldComponent implements OnInit, OnDestroy {
    public user: IUser | null = null;
    public currentTime: string = '';
    public networkStatus: string = 'online';
    public pendingSync: number = 0;
    public failedSync: number = 0;
    public syncingSync: number = 0;
    public syncQueueItems: any[] = [];
    public syncDetailOpen: boolean = false;
    public syncDetailLoading: boolean = false;
    public sessionMode: 'server' | 'cache' = 'server';
    
    private timeInterval: any = null;
    private _unsubNetwork: (() => void) | null = null;
    private _unsubSync: (() => void) | null = null;
    private syncRefreshSeq: number = 0;

    constructor(@Inject( Service)         public service: Service,@Inject( CDR)         public ref: CDR,@Inject( Router    )         public router: Router    ) { }

    public async ngOnInit() {
        await this.service.init(this);
        this.service.trigger.bind('render', () => {
            this.ref.detectChanges();
        });

        // Network status monitoring
        this.networkStatus = wiz.offline.network.status;
        this._unsubNetwork = wiz.offline.network.onStatusChange((status: string) => {
            this.networkStatus = status;
            if (status === 'online' || status === 'syncing') this.refreshSyncQueue(false);
            this.ref.detectChanges();
        });

        this._unsubSync = wiz.offline.sync.onPendingChange((count: number) => {
            this.pendingSync = count;
            this.refreshSyncQueue(false);
            this.ref.detectChanges();
        });

        try {
            if (!this.service.auth.allow(true)) {
                this.router.navigateByUrl('/login');
                return;
            }
            await this.loadSession();
            this.startClock();
            this.pendingSync = await wiz.offline.pendingSync();
            await this.refreshSyncQueue(false);
        } catch (e) {
            console.error('Field layout init error:', e);
        } finally {
            await this.service.loading.hide();
        }
        this.ref.detectChanges();
    }

    public ngOnDestroy() {
        if (this.timeInterval) clearInterval(this.timeInterval);
        if (this._unsubNetwork) this._unsubNetwork();
        if (this._unsubSync) this._unsubSync();
    }

    public async loadSession() {
        const { code, data } = await wiz.call('session');
        if (code !== 200) {
            if (wiz.offline.isOffline()) return;
            this.router.navigateByUrl('/login');
            return;
        }
        this.user = data;
        this.sessionMode = data && (data.offline === true || data.auth_mode === 'cache') ? 'cache' : 'server';
        this.ref.detectChanges();
    }

    private startClock() {
        this.updateTime();
        this.timeInterval = setInterval(() => {
            this.updateTime();
        }, 1000);
    }

    private updateTime() {
        const now = new Date();
        this.currentTime = now.toLocaleTimeString('ko-KR', {
            hour: '2-digit',
            minute: '2-digit'
        });
        this.ref.detectChanges();
    }

    public async logout() {
        await wiz.call('logout');
        try {
            localStorage.removeItem(AUTO_LOGIN_KEY);
            if (wiz.offline && wiz.offline.storage) {
                await wiz.offline.storage.clear('auth');
            }
        } catch (error) {
            console.error('Failed to clear auto login preference:', error);
        }
        this.router.navigateByUrl('/login');
    }

    public async toggleSyncDetails(event?: Event) {
        if (event) event.stopPropagation();
        this.syncDetailOpen = !this.syncDetailOpen;
        if (this.syncDetailOpen) await this.refreshSyncQueue(true);
        this.ref.detectChanges();
    }

    public closeSyncDetails(event?: Event) {
        if (event) event.stopPropagation();
        this.syncDetailOpen = false;
        this.ref.detectChanges();
    }

    public async forceSync(event?: Event) {
        if (event) event.stopPropagation();
        if (!wiz.offline.isOnline()) {
            this.syncDetailOpen = true;
            await this.refreshSyncQueue(true);
            return;
        }

        const result = await wiz.offline.forcSync();
        await this.refreshSyncQueue(false);
        if (result.success > 0 || result.failed > 0) {
            this.service.alert.show({
                title: result.failed > 0 ? '동기화 확인 필요' : '동기화 완료',
                message: `성공 ${result.success || 0}건, 실패 ${result.failed || 0}건`,
                status: result.failed > 0 ? 'warning' : 'success',
                action: '확인'
            });
        }
    }

    public openDiagnostics(event?: Event) {
        if (event) event.stopPropagation();
        this.router.navigateByUrl('/release/diagnostics');
    }

    public getNetworkStatusLabel(): string {
        if (this.networkStatus === 'online') return '온라인';
        if (this.networkStatus === 'syncing') return '동기화 중';
        return '오프라인';
    }

    public hasSyncQueueItems(): boolean {
        return this.syncQueueItems.length > 0;
    }

    public canRunSync(): boolean {
        return this.hasSyncQueueItems() && wiz.offline.isOnline();
    }

    public getSyncQueuePreview(): any[] {
        return this.syncQueueItems.slice(0, 5);
    }

    public getHiddenSyncCount(): number {
        return Math.max(0, this.syncQueueItems.length - this.getSyncQueuePreview().length);
    }

    public getSyncPanelTitle(): string {
        if (this.failedSync > 0) return `동기화 확인 ${this.failedSync}건`;
        if (this.pendingSync > 0) return `동기화 대기 ${this.pendingSync}건`;
        if (this.syncingSync > 0) return '동기화 진행 중';
        return '동기화 대기 없음';
    }

    public getSyncPanelDescription(): string {
        if (this.failedSync > 0) return '서버 반영에 실패한 작업이 있습니다. 온라인 상태에서 다시 동기화하세요.';
        if (this.pendingSync > 0) return '오프라인 저장/제출 작업이 서버 반영을 기다리고 있습니다.';
        if (this.syncingSync > 0) return '저장한 작업을 서버에 반영하는 중입니다.';
        return '현재 서버 반영을 기다리는 저장/제출 작업이 없습니다.';
    }

    public getSyncItemLabel(item: any): string {
        const entityType = String(item?.entity_type || '');
        const action = String(item?.action || '');
        if (entityType === 'checklist_response' && action === 'submit_response') return '체크리스트 제출';
        if (entityType === 'checklist_response' && action === 'save_response') return '체크리스트 저장';
        if (entityType === 'inspection_save') return '도면 점검 저장';
        if (action.includes('submit')) return '제출 작업';
        if (action.includes('save')) return '저장 작업';
        return entityType || action || '오프라인 작업';
    }

    public getSyncItemDescription(item: any): string {
        const id = item?.entity_id ? `ID ${item.entity_id}` : '로컬 작업';
        const updatedAt = this.formatSyncTime(item?.updated_at || item?.created_at);
        return updatedAt ? `${id} · ${updatedAt}` : id;
    }

    public getSyncItemStatusLabel(status: string): string {
        if (status === 'syncing') return '동기화 중';
        if (status === 'failed') return '실패';
        return '대기';
    }

    public queueStatusClass(item: any): string {
        const status = String(item?.status || 'pending');
        if (status === 'failed') return 'failed';
        if (status === 'syncing') return 'syncing';
        return 'pending';
    }

    private async refreshSyncQueue(showLoading: boolean = false) {
        const seq = ++this.syncRefreshSeq;
        if (showLoading) this.syncDetailLoading = true;
        try {
            const storage = wiz?.offline?.storage;
            let items: any[] = [];
            if (storage && typeof storage.getSyncQueueItems === 'function') {
                items = await storage.getSyncQueueItems();
            } else if (storage && typeof storage.getAll === 'function') {
                items = await storage.getAll('sync_queue');
            }
            if (seq !== this.syncRefreshSeq) return;

            const activeItems = (Array.isArray(items) ? items : [])
                .filter((item: any) => ACTIVE_SYNC_STATUSES.includes(String(item?.status || 'pending')))
                .sort((a: any, b: any) => Number(a?.created_at || 0) - Number(b?.created_at || 0));

            this.syncQueueItems = activeItems;
            this.pendingSync = activeItems.filter((item: any) => String(item?.status || 'pending') === 'pending').length;
            this.failedSync = activeItems.filter((item: any) => String(item?.status || '') === 'failed').length;
            this.syncingSync = activeItems.filter((item: any) => String(item?.status || '') === 'syncing').length;
        } catch (error) {
            console.error('Failed to load sync queue:', error);
        } finally {
            if (seq === this.syncRefreshSeq) this.syncDetailLoading = false;
            this.ref.detectChanges();
        }
    }

    private formatSyncTime(value: any): string {
        if (!value) return '';
        const date = new Date(typeof value === 'number' ? value : String(value));
        if (Number.isNaN(date.getTime())) return '';
        return date.toLocaleString('ko-KR', {
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        });
    }
}

export default LayoutFieldComponent;